import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { savePaymentMethod } from "../../../actions/action_payment";
import PaymentService from "../../../api/services/PaymentService";
import * as constants from "../../../constants";
import { log } from "../../../utils";
import logoAtone from "../../../assets/img/icons/logo_atone.png";
import PopupAtoneDescription from "./PopupAtoneDescription";
import RadioInput from "./RadioInput";
import PaymentCardBrands from "../../common/PaymentCardBrands";
import ListPaymentCardModal from "./ListPaymentCardModal";
import ErrorAlert from "./ErrorAlert";

function Payment(props) {
  const [showListCard, setShowListCard] = useState(false);
  const [showAtoneDescription, setShowAtoneDescription] = useState(false);
  const [atoneHide, setAtoneHide] = useState(false);

  useEffect(() => {
    if (!window.Atone) {
      setAtoneHide(true);
    } else {
      setAtoneHide(false);
    }
  }, [window.Atone]);

  const fetchPaymentDefault = async (userId) => {
    props.setLoading(true);
    try {
      const { data } = await PaymentService.getDefaultCard(userId);
      if (data.list.length > 0) {
        props.savePaymentMethod(data.list[0]);
      }
    } catch (error) {
      log('getDefaultCard error with userId ' + props.userInfo.userId);
      // TODO: showError
    }
    props.setLoading(false);
  };

  const onChangePaymentType = (e) => {
    props.setPaymentType(parseInt(e.target.value));
    props.setUseBankTransfer(parseInt(e.target.value) === constants.PAYMENT_TYPE_VERITRANS_ATM || parseInt(e.target.value) === constants.PAYMENT_TYPE_VERITRANS_INTERNET_BANKING);
  };

  const onClickBankTransfer = () => {
    props.setUseBankTransfer(true);
    props.setPaymentType('');
  }

  useEffect(() => {
    if (props.readOnly) {
      return;
    }
    if (props.userInfo?.userId) {
      fetchPaymentDefault(props.userInfo.userId);
    }

    if (props.oldInput.donateAmount && props.oldInput.donateAmount >= 10000) {
      props.setDisableBankTransfer(false);

      if (props.oldInput.paymentType === constants.PAYMENT_TYPE_VERITRANS_ATM ||
        props.oldInput.paymentType === constants.PAYMENT_TYPE_VERITRANS_INTERNET_BANKING) {
        props.setUseBankTransfer(true);
      }
    }

    props.setPaymentType(constants.PAYMENT_TYPE_CREDIT_CARD);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className={props.className}>
        {props.paymentTypeError && <ErrorAlert className="mb-3">{props.paymentTypeError}</ErrorAlert>}

        <div className="d-flex justify-content-between">
          <RadioInput
            inputName="paymentType"
            inputValue={constants.PAYMENT_TYPE_CREDIT_CARD}
            disabled={props.readOnly && props.paymentType !== constants.PAYMENT_TYPE_CREDIT_CARD}
            checked={props.paymentType === constants.PAYMENT_TYPE_CREDIT_CARD}
            onChange={onChangePaymentType}
          >クレジットカードで決済</RadioInput>
          {!props.readOnly && props.paymentType === constants.PAYMENT_TYPE_CREDIT_CARD && props.userInfo.userId &&
            <button
              className="btn-outline btn-update-credit-card"
              onClick={() => setShowListCard(true)}
            >{!props.paymentMethod || props.paymentMethod.length === 0 ? '登録する' : '変更する'}</button>
          }
        </div>
        {props.paymentType === constants.PAYMENT_TYPE_CREDIT_CARD && props.userInfo.userId && <>
          {!props.paymentMethod || props.paymentMethod.length === 0
            ?
              <div className="fs-12px fw-400 mt-2">クレジットカード情報を登録してください</div>
            :
              <div className="mt-2">
                <div>****-****-****-{props.paymentMethod.last4}</div>
                <div>有効期限：{props.paymentMethod.expireMonth.toString().padStart(2, '0')}/{props.paymentMethod.expireYear}</div>
              </div>
          }
        </>}
        {!props.readOnly && <div className="mt-3">
          <PaymentCardBrands className="justify-content-between" />
        </div>}

        <div className="mt-3">
          <RadioInput
            inputName="paymentType"
            inputValue={constants.PAYMENT_TYPE_PAYPAY}
            disabled={(props.readOnly && props.paymentType !== constants.PAYMENT_TYPE_PAYPAY) || props.disabledNonSubscription}
            checked={props.paymentType === constants.PAYMENT_TYPE_PAYPAY}
            onChange={onChangePaymentType}
          >PayPayで決済</RadioInput>
        </div>

        <div className="mt-3">
          <RadioInput
            inputName="paymentType"
            inputValue={constants.PAYMENT_TYPE_ONEPAY_ALIPAY}
            disabled={(props.readOnly && props.paymentType !== constants.PAYMENT_TYPE_ONEPAY_ALIPAY) || props.disabledNonSubscription}
            checked={props.paymentType === constants.PAYMENT_TYPE_ONEPAY_ALIPAY}
            onChange={onChangePaymentType}
          >Alipayで決済</RadioInput>
        </div>

        <div className="mt-3">
          {!atoneHide &&
          <RadioInput
            inputName="paymentType"
            inputValue={constants.PAYMENT_TYPE_ATONE}
            disabled={(props.readOnly && props.paymentType !== constants.PAYMENT_TYPE_ATONE) || props.disabledNonSubscription}
            checked={props.paymentType === constants.PAYMENT_TYPE_ATONE}
            onChange={onChangePaymentType}
          >atone 翌月払い（コンビニ/口座振替）</RadioInput>
          }
          {!atoneHide &&
            <div className={(props.readOnly && props.paymentType !== constants.PAYMENT_TYPE_ATONE) || props.disabledNonSubscription ? "text-gray-B1ADAD mb-2" : "text-red mb-2"}>※atoneアカウントをお持ちではない方は、会員登録が必要です</div>
          }
          {!props.readOnly && <div className="atone-description">
            {!atoneHide ? (
            <>
              <div>
                <a
                  href="https://atone.be/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={logoAtone} alt="Atone" />
                </a>
              </div>
            </>
            ) : (
              <div className="fs-12">
                ※広告ブロック等の理由により、atone決済が表示されません。<br />
                atone決済をご利用ご希望の方は、ご利用のブラウザを変更してお試しください。
              </div>
            )}
            <span onClick={() => setShowAtoneDescription(true)}>atone説明文</span>
          </div>}
        </div>

        <div className="mt-3">
          <RadioInput
            disabled={(props.readOnly && !props.useBankTransfer) || props.disabledNonSubscription || props.disableBankTransfer}
            checked={props.useBankTransfer}
            onChange={onClickBankTransfer}
          >銀行振込（1万円以上で利用可）</RadioInput>
          {props.useBankTransfer && (
            <>
              <div className="fs-14 fw-700 mt-2 mb-1">振込方法</div>
              <select
                className="select-round select-round-1 form-control select-control"
                value={props.paymentType}
                onChange={onChangePaymentType}
              >
                <option value=''>選択してください</option>
                <option value={constants.PAYMENT_TYPE_VERITRANS_ATM}>ATM</option>
                <option value={constants.PAYMENT_TYPE_VERITRANS_INTERNET_BANKING}>ネットバンク</option>
              </select>
              <div className="payment-warning mt-2">
                <div className="payment-warning-icon">
                  <svg width="25" height="24" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.68036 21.1482H20.4479C22.0602 21.1482 23.0653 19.4782 22.2591 18.1482L14.3754 5.13825C13.5692 3.80825 11.559 3.80825 10.7528 5.13825L2.86908 18.1482C2.06291 19.4782 3.06801 21.1482 4.68036 21.1482ZM12.5641 14.1482C11.9883 14.1482 11.5171 13.6982 11.5171 13.1482V11.1482C11.5171 10.5982 11.9883 10.1482 12.5641 10.1482C13.14 10.1482 13.6111 10.5982 13.6111 11.1482V13.1482C13.6111 13.6982 13.14 14.1482 12.5641 14.1482ZM13.6111 18.1482H11.5171V16.1482H13.6111V18.1482Z" fill="#F9AC39"/>
                  </svg>
                </div>
                <div className="payment-warning-text">
                  【ATMでお振込みをご希望の方へ】
                  <br />
                  このあとの「支援内容の確認」画面で内容を確定すると、振込に必要な情報（収納機関コード・顧客番号・確認番号など）が表示されます。
                  <br />
                  振込に必要な情報は発券から翌日までが有効期限となりますのでご注意ください。
                  <br />
                  <a href="https://www.veritrans.co.jp/user_support/bank_atm.html" target="_blank" className="text-decoration-underline color-47ACFF">ATM操作方法はこちら</a>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <ListPaymentCardModal show={showListCard} handleClose={() => setShowListCard(false)} />
      <PopupAtoneDescription show={showAtoneDescription} handleClose={() => setShowAtoneDescription(false)} />
    </>
  );
}

const mapStateToProps = state => ({
  userInfo: state.userInfo,
  paymentMethod: state.paymentMethod,
  oldInput: state.gochiKid.donate,
});

const mapDispatchToProps = dispatch => ({
  savePaymentMethod: (paymentMethod) => dispatch(savePaymentMethod(paymentMethod))
});

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
